import AppLink from "../router/app-link";
import PurchaseTicketApi from "../../api/purchase-ticket";
import { useContext, useState } from "react";
import AuthContext from "../../components/auth-context";
import Ticket from "../../types/ticket";

export interface CartMenuItemProps {
  type: string;
  titles: string[];
  id: string;
  onCancel: () => void;
}

function CartMenuItem({ type, titles, id }: CartMenuItemProps) {
  const context = useContext(AuthContext);
  const [ticket, setTicket] = useState<Ticket | null>(
    context.tickets.length > 0 ? context.tickets[0] : null
  );

  if (!ticket) return null;
  const handleCancle = () => {
    const purchaseTicketApi = new PurchaseTicketApi(context);
    purchaseTicketApi.delete(ticket!.id).then(() => {
      purchaseTicketApi
        .getAll()
        .then((data) => {
          context.setTickets(data);
          setTicket(data.length > 0 ? data[0] : null);
        })
        .catch(() => {});
    });
  };
  return (
    <span title="تکمیل خرید">
      <div className="clearfix">
        <p>
          <strong className="blue">
            <i className="ace-icon fa fa-shopping-basket"></i>
            {" " + type}
          </strong>
        </p>
        {titles.map((title) => (
          <p key={title}>{title}</p>
        ))}
        <p style={{ marginRight: "10px" }}>
          <AppLink className="btn btn-xs btn-success" to={`/payment/${id}`}>
            پرداخت
          </AppLink>{" "}
          <button className="btn btn-xs btn-danger" onClick={handleCancle}>
            لغو خرید
          </button>
        </p>
      </div>
    </span>
  );
}

export default CartMenuItem;
